import Header from "../../../components/header/Header";
import StarChartOrgMainContainer from "../conatiner/starChartOrg.main.container/starChartsOrg.main.container";


const StarChartOrgPage = () => {


  return (
    <>
      <Header title="Star Charts" />
      <StarChartOrgMainContainer />
    </>
  )
}

export default StarChartOrgPage
